import { useState, useEffect } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

const links = [
  { label: "Services", href: "#services" },
  { label: "À propos", href: "#apropos" },
  { label: "Comment ça marche", href: "#process" },
  { label: "Galerie", href: "#galerie" },
  { label: "Avis", href: "#avis" },
  { label: "Devis", href: "#devis" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-transform duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/80 border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-2">
          <span className="font-display font-bold text-lg sm:text-xl tracking-tight text-brand-navy">
            KING <span className="text-brand-red">OF</span> SOURCING
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-sm font-medium text-brand-navy/80 hover:text-brand-red transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-brand-whatsapp px-5 py-2.5 text-sm font-bold text-white hover:-translate-y-0.5 transition-transform duration-300"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
          <button
            className="md:hidden text-brand-navy"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-black/5 px-5 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-brand-navy"
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-whatsapp px-5 py-3 text-sm font-bold text-white"
          >
            <MessageCircle size={16} /> Discuter sur WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};
